// Employee accounts that must never be deactivated and that only their owner
// may edit. The API enforces this (EMPLOYEE_IS_PROTECTED) — this list only
// hides the actions in the UI.
// Keep in sync with PROTECTED_EMPLOYEE_EMAILS in api/src/constants/general.ts.
export const PROTECTED_EMPLOYEE_EMAILS = ['gregor.kleibl@cashy.at']

export const isProtectedEmployee = (email?: string | null) =>
  !!email && PROTECTED_EMPLOYEE_EMAILS.includes(email.toLowerCase())
